<template>
	<div class="wrapper">
		<TheTopbar />
		<div class="main">
			<slot />
		</div>
		<TheFooter />
	</div>
</template>

<script>
import TheTopbar from '@/components/TheTopbar.vue';
import TheFooter from '@/components/TheFooter.vue';

export default {
	name: 'LayoutDefault',

	components: {
		TheTopbar,
		TheFooter,
	},
};
</script>

<style lang="scss" scoped>
.wrapper {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	background-color: $color-accent-700;

	.main {
		flex-grow: 1;
	}
}
</style>
